import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CheckboxComponent } from './checkbox.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule
    ],
    exports: [CheckboxComponent],
    declarations: [CheckboxComponent],
    providers: [],
})
export class CheckboxModule { }
